<div class="most-consumed-container">
  <div class="most-consumed">
    <div class="highest-consumed-label">
      <sh-icon size="s" icon="warning"></sh-icon>
      <sh-text size="title-1">{{
        'spareparts.highestConsumed' | translate
      }}</sh-text>
    </div>
    <div class="highest-consumed-label description">
      <sh-text color="secondary">{{ mostConsumedDescription }}</sh-text>
    </div>
    <div class="highest-consumed-label">
      <sh-text size="title-1">{{
        'spareparts.mostConsumedFrequency' | translate: { units: units }
      }}</sh-text>
    </div>
  </div>
</div>
